import { render, staticRenderFns } from "./FormPageBulkSCT.vue?vue&type=template&id=3f00cb1a&scoped=true&"
import script from "./FormPageBulkSCT.vue?vue&type=script&lang=js&"
export * from "./FormPageBulkSCT.vue?vue&type=script&lang=js&"
import style0 from "./FormPageBulkSCT.vue?vue&type=style&index=0&id=3f00cb1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f00cb1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f00cb1a')) {
      api.createRecord('3f00cb1a', component.options)
    } else {
      api.reload('3f00cb1a', component.options)
    }
    module.hot.accept("./FormPageBulkSCT.vue?vue&type=template&id=3f00cb1a&scoped=true&", function () {
      api.rerender('3f00cb1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Manda/FormPageBulkSCT.vue"
export default component.exports